const tabs = document.querySelectorAll("[role='tab']");
const panels = document.querySelectorAll(".switcher__panel");

function showTab(tab) {
  // turn everyone else off
  tabs.forEach((t) => {
    t.classList.remove("is-active");
    t.setAttribute("aria-selected", "false");
  });

  panels.forEach((panel) => {
    panel.classList.remove("is-active");
    panel.hidden = true;
  });

  // turn this one on
  tab.classList.add("is-active");
  tab.setAttribute("aria-selected", "true");
  const panel = document.getElementById(tab.getAttribute("aria-controls"));
  panel.hidden = false;
  panel.classList.add("is-active");
}

// Warm up image decoding so the first tab switch is as instant as later ones.
// The hidden-panel <img>s are fetched eagerly (they're in the HTML), but
// browsers defer decoding display:none images until they're actually shown,
// which causes a one-frame blank the first time each panel is revealed.
// decode() forces that work to happen up front instead of on first click.
document.querySelectorAll(".switcher__panel img").forEach((img) => {
  if (typeof img.decode === "function") {
    img.decode().catch(() => {});
  }
});

tabs.forEach((tab) => {
  tab.addEventListener("click", () => showTab(tab));
  tab.addEventListener("keydown", (e) => {
    if (!["ArrowLeft", "ArrowRight"].includes(e.key)) {
      return;
    }

    const list = Array.from(tabs);
    const i = list.indexOf(tab);
    const next =
      e.key === "ArrowRight"
        ? list[(i + 1) % list.length]
        : list[(i - 1 + list.length) % list.length];

    next.focus();
    showTab(next);
  });
});
